import { render, staticRenderFns } from "./PanoramasTest.vue?vue&type=template&id=06d752e5&scoped=true"
import script from "./PanoramasTest.vue?vue&type=script&lang=js"
export * from "./PanoramasTest.vue?vue&type=script&lang=js"
import style0 from "./PanoramasTest.vue?vue&type=style&index=0&id=06d752e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d752e5",
  null
  
)

export default component.exports